<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="accessForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1">Email</label>
        </div>
        <div class="input-group col-8">
          <input class="form-control rb-input" placeholder="Please enter email." formControlName="email" type="text" />
          <div class="col-12 error-mssg" *ngIf="(formControl.email.touched || submitted) && formControl.email.errors">
            <label class="text-danger" *ngIf="formControl.email.errors.required">*Email is required.</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="isActive" class="text-black-1" translate> User role</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="[{ name: 'Admin', value: 'admin' }]"
            optionLabel="name"
            optionValue="value"
            formControlName="role"
            placeholder="Select role"
          ></p-dropdown>
          <div class="col-12 error-mssg" *ngIf="(formControl.role.touched || submitted) && formControl.role.errors">
            <label for="role" class="text-danger" *ngIf="formControl.role.errors.required">
              *Please select role.
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
